import { useEffect, useState } from 'react';
import { listTemplateOptions, mergeTemplateOptions } from '../../pages/medstudent/templateCatalog';

/**
 * Template dropdown options, with the built-ins available synchronously.
 *
 * Only the custom-template half needs I/O, and that call can hang on a
 * deadlocked auth session (getCurrentUserName reaches
 * supabase.auth.getSession(), and this app runs multiple GoTrueClient
 * instances against one storage key). So state is seeded with the built-ins
 * and the full list merges in when it arrives — the dropdown is never empty
 * and never blocks on the network.
 */
export function useTemplateOptions({ includeFollowUps = false } = {}) {
  const [options, setOptions] = useState(() => mergeTemplateOptions([], { includeFollowUps }));
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;
    setLoading(true);
    listTemplateOptions({ includeFollowUps })
      .then((next) => { if (alive && Array.isArray(next)) setOptions(next); })
      .catch(() => { /* keep the built-in fallback already in state */ })
      .finally(() => { if (alive) setLoading(false); });
    return () => { alive = false; };
  }, [includeFollowUps]);

  return { options, loading };
}
